module.exports = __webpack_public_path__ + "img/usa.ae656592.svg";